var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'help-box ' + _vm.pos},[_c('h3',[_vm._v(_vm._s(_vm.data.Header))]),_c('p',{staticClass:"text-uppercase mb-1 pb-2"},[_c('span',[_vm._v(_vm._s(_vm.data.Txt))]),_c('DoPhoneLink',{attrs:{"value":_vm.data}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }